import { endOfMonth, endOfWeek, startOfMonth, startOfWeek, subDays, subMonths, subWeeks } from 'date-fns';
import { DATE_RANGE_CONFIG_KEY, DateRange } from './types';
import createDateWithZeroTimeFrom from '../../utils/createDateWithZeroTimeFrom';

class DateRangeProvider {
    private readonly predefinedRanges = {
        lastWeek: this.lastWeek(),
        lastMonth: this.lastMonth(),
    };

    public getLastNDaysRange(numberOfDays: number): DateRange {
        const yesterday = subDays(new Date(), 1);
        const dayOnDaysAgo = subDays(yesterday, numberOfDays - 1);
        return this.getRangeWithIgnoredTime(dayOnDaysAgo, yesterday);
    }

    public getPredefinedRange(key: DATE_RANGE_CONFIG_KEY): DateRange {
        return this.predefinedRanges[key];
    }

    private lastWeek(): DateRange {
        const dayOneWeekAgo = subWeeks(new Date(), 1);
        const startOfLastWeek = startOfWeek(dayOneWeekAgo, { weekStartsOn: 1 });
        const endOfLastWeek = endOfWeek(dayOneWeekAgo, { weekStartsOn: 1 });
        return this.getRangeWithIgnoredTime(startOfLastWeek, endOfLastWeek);
    }

    private lastMonth(): DateRange {
        const result = subMonths(new Date(), 1);
        const startDate = startOfMonth(result);
        const endDate = endOfMonth(result);
        return this.getRangeWithIgnoredTime(startDate, endDate);
    }

    private getRangeWithIgnoredTime(start: Date, end: Date): DateRange {
        return { start: createDateWithZeroTimeFrom(start), end: createDateWithZeroTimeFrom(end) };
    }
}

const dateRangeProvider = new DateRangeProvider();

export { dateRangeProvider };
export default DateRangeProvider;
